<template>
    <div class="files-tab">
        <div class="use-pagination-block-bottom">
            <div class="row">
                <div class="col-md-8">
                    <div class="table-responsive  overflow-y-hidden">
                        <b-table
                                hover
                                :items="computedFilesList"
                                :fields="filesTableFields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                table-class="tab-special mb-0 estimate-items"
                        >
                            <template v-slot:head()="data">
                                <div v-if="!data.field.sortable">{{data.label}}</div>
                                <div v-if="data.field.sortable" class="table-sorting">{{data.label}}<i></i></div>
                            </template>
                            <template v-slot:cell(file_name)="data">
                                <a class="file-name" target="_blank"
                                   :download="data.item.file_name"
                                   :href="data.item.url"
                                   v-b-tooltip.hover="{customClass: 'ps-tooltip', title: 'Open and View PDF', placement:'bottom'}">
                                    {{ data.item.file_name|reshapeString }}

                                </a>
                            </template>
                            <template v-slot:cell(type2)="data">
                                <multiselect
                                        v-model="data.item.type3"
                                        :options="typesOfFile"
                                        track-by="value"
                                        label="value"
                                        :showLabels="false"
                                        :option-height="29"
                                        :max-height="203"
                                        :allow-empty="false"
                                        :close-on-select="true"
                                        placeholder="Select Type"
                                        @select="setFileType(data.item)"
                                        @open="openMultiselect"
                                        @close="closeMultiselect"
                                        open-direction="bottom"
                                />
                            </template>
                            <template v-slot:cell(created_on)="data">
                                <span class="uploaded-by">{{ data.item.created_on | formatDatetime }}</span>
                            </template>
                            <template v-slot:cell(fileSize)="data">
                                {{ data.item.fileSize | formatFileSize }}
                            </template>
                            <template v-slot:cell(actions)="data">
                                <button
                                        class="btn-trash"
                                        @click="deleteFile(data.item)"
                                        v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title:'Delete File', placement:'leftbottom'}"
                                ></button>
                            </template>
                        </b-table>
                        <!--                        <div :style="{'min-height':(500-60*filesList.length)>0?(500-60*filesList.length)+'px':0+'px'}" style=" border:none"></div>-->
                        <div v-if="isOpenMultiselect" style="min-height:200px; border:none"></div>
                    </div>
                </div>
                <div class="col-md-4">
                    <file-upload
                            type="file"
                            :api-urls="urls"
                            :files-accepted="'application/pdf, image/jpeg'"
                            :value="[]"
                            :object-id="0"
                            :dynamic-width="true"
                            :after-upload-function-override="afterUpload"
                            :after-upload="afterUploadEmitted"
                    >
                    </file-upload>
                </div>
            </div>
        </div>
        <div class="assessments-pagination">
          <block-pagination
              :role="'files'"
              :arrayOfSomeone="computedFilesList"
              :arrayOfSomeoneFiltered="computedFilesList"
              :currentPage="currentPage"
              @changedCurrentPage="value => currentPage = value"
              :perPage="perPage"
              @changedPerPage="value => perPage = value"
          >
          </block-pagination>
        </div>
    </div>
</template>

<script>
    import FileUpload from '@/components/FileUpload';
    import Axios from "axios/index";
    import Multiselect from 'vue-multiselect';
    import BlockPagination from '../../../components/utility/block-pagination';

    export default {
        name: 'files-tab',
        components: {
            FileUpload,
            Multiselect,
            BlockPagination,
        },
        props: {
            filesList: {
                type: Array,
                default: () => [],
            },
            assessmentId: null,
        },
        mounted() {
            console.log(this.$route.params.claimId);
        },

        data() {
            return {
                isOpenMultiselect: false,
                typesOfFile: [
                    {key: 'additionals_invoice', value: 'Additionals Invoice'},
                    {key: 'additionals_quote', value: 'Additionals Quote'},
                    {key: 'rental_quote', value: 'Rental Quote'},
                    {key: 'rental_invoice', value: 'Rental Invoice'},
                    {key: 'repair_invoice', value: 'Vech/Repair Invoice'},
                    {key: 'repair_quote', value: 'Vech/Repair Quote'},
                    {key: 'assessment', value: 'Assessment'},
                    {key: 'assessment_report', value: 'Assessment Report'},
                    {key: 'misc', value: 'Misc'},
                ],
                contextOpenEvent: null,
                perPage: 10,
                currentPage: 1,
                filesTableFields: [
                    {
                        label: 'File Name',
                        key: 'file_name',
                        sortable: true,
                        tdClass: 'file-name',
                        thClass: 'file-name',
                    },
                    {
                        label: 'Type',
                        key: 'type2',
                        sortable: true,
                        tdClass: 'type-2',
                        thClass: 'type-2',
                    },
                    {
                        label: 'Date',
                        key: 'created_on',
                        sortable: true,
                        tdClass: 'uploaded-date',
                        thClass: 'uploaded-date',
                    },
                    {
                        label: 'Uploaded by',
                        key: 'uploaded_by',
                        sortable: true,
                        tdClass: 'uploaded-by',
                        thClass: 'uploaded-by',
                    },
                    {
                        label: 'File Size',
                        key: 'fileSize',
                        sortable: true,
                        tdClass: 'file-size',
                        thClass: 'file-size',
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                        sortable: false,
                        tdClass: 'actions',
                        thClass: 'actions',
                    },
                ],
            };
        },
        computed: {
            computedFilesList() {
                let vm = this;
                this.filesList.forEach((item) => {
                    vm.$set(item, 'type3', vm.getFileType2Label(item.type2));
                });
                return this.filesList;
            },
            urls() {
                return {uploadFile: `/ir/assessment/${this.assessmentId}/add-file`};
            },
        },
        methods: {
            openMultiselect() {
                this.isOpenMultiselect = true;
            },
            closeMultiselect() {
                setTimeout(() => {
                    this.isOpenMultiselect = false;
                },100)
            },
            changeFile(file) {
                this.$emit('changeFile', file);
            },
            setFileType(item, type3) {
                this.$nextTick(() => {
                    console.log('type3', type3);
                    console.log('item', item);
                    item.type2 = item.type3.key;
                    let file = Object.assign({}, item);
                    console.log('file', file);
                    this.changeFile(file);
                });
            },
            deleteFile(item) {
                if (!confirm(`Confirm you want to DELETE this file`)) {
                    return;
                }
                Axios.post(`/ir/assessment/${this.assessmentId}/remove-file`, {fileId: item.id})
                    .then(response => {
                        if (response.data && response.data._status) {
                            this.$toast.success('File removed!');
                            this.$emit('fileUploaded');
                        } else {
                            this.$toast.error('Unable to remove file');
                        }
                    })
                    .catch(e => {
                        this.$toast.error('Unable to remove file');
                        console.error(e);
                    });
            },
            afterUpload() {
                // console.log('File uploded');
                this.$toast.success('File uploaded');
                this.$emit('fileUploaded');
            },
            afterUploadEmitted() {
                // console.log('File uploded2');
                //   this.$toast.success('File uploaded');
                this.$emit('fileUploaded');
            },
            getFileType2Label(type) {
                let types = {
                    additionals_invoice: 'Additionals Invoice',
                    additionals_quote: 'Additionals Quote',
                    rental_quote: 'Rental Quote',
                    rental_invoice: 'Rental Invoice',
                    repair_invoice: 'Vech/Repair Invoice',
                    repair_quote: 'Vech/Repair Quote',
                    assessment: 'Assessment',
                    assessment_report: 'Assessment Report',
                    misc: 'Misc',
                };
                return {key: type, value: types[type]} || {};
            },
        },
    };
</script>

<style scoped>
    .files-tab {
        max-width: 1300px;
    }

    .btn-trash {
        background: url(data:image/svg+xml;base64,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) no-repeat center left;
        border: none;
        width: 20px;
        height: 20px;
    }

</style>

<style>
    .assessments-pagination .pagination-block-paginator {
      right: 33%;
    }
    .files-tab .b-table td {
        color: #1C1F39;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
    }

    .files-tab table.table .actions {
        padding: 0 5px 0 5px;
        width: 50px;
        text-align: center;
    }

    .files-tab table.table .file-size {
        padding-left: 5px !important;
        padding-right: 5px !important;
        text-align: right;
    }

    .files-tab table.table .uploaded-by {
        padding-left: 5px!important;
        padding-right: 5px!important;
        min-width: 103px;
        width: 103px;
    }

    .files-tab table.table .uploaded-date {
        width: 150px !important;
        min-width: 150px !important;
        padding-left: 5px!important;;
        padding-right: 5px!important;;
    }

    .files-tab table.table td.type-2 {
        text-align: right;
        min-width: 170px;
        width: 170px;
        padding: 0 5px;
    }

    .files-tab table.table td.type-2 .multiselect__select {
        font-weight: 400;
    }

    .files-tab table.table th.uploaded-date,
    .files-tab table.table th.type-2 {
        text-align: center;
    }

    .files-tab table.table td.file-size {
        text-align: right;
        min-width: 75px;
        width: 75px;
    }

    .files-tab .show-type2-dropdown .btn {
        border: none;
        background-color: #FFFFFF !important;
        color: #333333 !important;
        box-shadow: none;
        text-align: right;
    }
</style>

